<script setup lang="ts">
import type { KanbanComment } from '@entities/kanban-comment'

import { faPlus } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { useKanbanCommentsStore } from '@entities/kanban-comment'
import { IconContainer } from '@shared/ui/other'
import { CardAdmin } from '@shared/ui/cards'
import { BtnPrimary } from '@shared/ui/buttons'

import { useKanbanComments } from '../model/comment/comments.hook'
import KanbanCommentItem from './comment/KanbanCommentItem.vue'
import KanbanCommentForm from './comment/KanbanCommentForm.vue'

defineOptions({
  name: 'KanbanComments',
})

const props = withDefaults(defineProps<KanbanCommentsProps>(), {
  title: 'All comments',
  additionalData: false,
  fullwidth: false,
  saveApi: undefined,
})

interface KanbanCommentsProps {
  title?: string
  fullwidth?: boolean
  additionalData?: boolean
  saveApi?: (comment: string) => Promise<KanbanComment | null>
  updateApi: (commentId: number, comment: string) => Promise<KanbanComment | null>
}

const kanbanCommentsStore = useKanbanCommentsStore()

const {
  refShowForm,
  refComment,
  refLabel,
  refIsDisabled,
  setShowForm,
  setCloseForm,
  setComment,
  setEditComment,
  setSubmitComment,
} = useKanbanComments({
  saveApi: props.saveApi,
  updateApi: props.updateApi,
})
</script>

<template>
  <CardAdmin
    :fullwidth="fullwidth"
    :title="title"
  >
    <template #header>
      <BtnPrimary
        v-if="!!saveApi && !refShowForm"
        text="Add comment"
        @click="setShowForm"
      >
        <template #iconRight>
          <IconContainer>
            <FontAwesomeIcon :icon="faPlus" />
          </IconContainer>
        </template>
      </BtnPrimary>
    </template>
    <KanbanCommentForm
      v-if="refShowForm"
      :label="refLabel"
      :comment="refComment"
      :disabled="refIsDisabled"
      @input:comment="setComment"
      @click:submit="setSubmitComment"
      @click:cancel="setCloseForm"
    />
    <KanbanCommentItem
      v-for="comment in kanbanCommentsStore.getComments"
      :key="comment.id"
      :comment="comment"
      :additional-data="additionalData"
      @click:edit="setEditComment"
    />
  </CardAdmin>
</template>

<style scoped lang="scss" src="./KanbanComments.scss" />
